// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-datatable .p-datatable-header {
    color: black;
    background: #f5f5f5;
    padding: 0;
    border: none;
}

::ng-deep .p-datatable-thead > tr > th {
    background-color: silver !important;
    font-size: 0.8rem;
    padding: 0.5rem 0.75rem !important;
}

::ng-deep .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.85rem;
    padding: 0.4rem 0.75rem !important;
    color: #333;
}

::ng-deep .p-datatable .p-datatable-tbody > tr > td .btn {
    font-size: 0.875rem;
    padding: 0.35rem 0.7rem;
}

::ng-deep .p-datatable .p-paginator {
    font-size: 0.85rem;
    padding: 0.3rem 0.5rem !important;
}

.data-cache-header {
    text-align: right;
    margin-bottom: 8px;
}

.data-cache-header .btn {
    font-size: 0.82rem;
    padding: 0.3rem 0.65rem;
}

.no-overflow {
    overflow: hidden;
}

.well {
    border: solid 1px #d3d3d3;
    background-color: #fff;
    padding: 10px 15px;
    border-radius: 4px;
    margin: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/data-cache-manager/data-cache-manager.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["::ng-deep .p-datatable .p-datatable-header {\r\n    color: black;\r\n    background: #f5f5f5;\r\n    padding: 0;\r\n    border: none;\r\n}\r\n\r\n::ng-deep .p-datatable-thead > tr > th {\r\n    background-color: silver !important;\r\n    font-size: 0.8rem;\r\n    padding: 0.5rem 0.75rem !important;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-tbody > tr > td {\r\n    font-size: 0.85rem;\r\n    padding: 0.4rem 0.75rem !important;\r\n    color: #333;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-tbody > tr > td .btn {\r\n    font-size: 0.875rem;\r\n    padding: 0.35rem 0.7rem;\r\n}\r\n\r\n::ng-deep .p-datatable .p-paginator {\r\n    font-size: 0.85rem;\r\n    padding: 0.3rem 0.5rem !important;\r\n}\r\n\r\n.data-cache-header {\r\n    text-align: right;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.data-cache-header .btn {\r\n    font-size: 0.82rem;\r\n    padding: 0.3rem 0.65rem;\r\n}\r\n\r\n.no-overflow {\r\n    overflow: hidden;\r\n}\r\n\r\n.well {\r\n    border: solid 1px #d3d3d3;\r\n    background-color: #fff;\r\n    padding: 10px 15px;\r\n    border-radius: 4px;\r\n    margin: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
